export const toCamelCase = (str) => {
  if (!str) return null

  // Split the string on spaces, dashes, and underscores.
  var words = str.toLowerCase().split(/[\s_-]+/)

  // Capitalize the first letter of each word, except the first one,
  // add the remaining part of the word.
  for (var i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1)
  }

  // Join words and return.
  return words.join('')
}

export const maskString = (str) => {
  if (!str) return null

  if (str.length > 4) {
    return (
      str.slice(0, -4).replace(/./g, '*').slice(-6) + str.slice(-4)
    )
  } else {
    return str
  }
}
